<template>
  <div>
    <Layout :pagetitle="$t('Campaigns')">
      <form autocomplete="off" @submit.prevent="saveCampaign">
        <b-card>
          <b-row>
            <b-col>
              <h4>{{ $t('Campaign') }}</h4>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="6">
              <label>{{ $t('Name') }}</label>
              <b-form-input :trim="true" autocomplete="off" required v-model="name" />
            </b-col>
            <b-col md="6">
              <label>{{ $t('Page') }}</label>
              <b-form-input :trim="true" autocomplete="off" v-model="page" />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <label>Utm campaign</label>
              <b-form-input :trim="true" autocomplete="off" required v-model="utmCampaign" @keyup="formatUtms" />
            </b-col>
            <b-col md="4">
              <label>{{ $t('Promo code') }}</label>
              <b-form-input :trim="true" autocomplete="off" v-model="promocode" />
            </b-col>
            <b-col md="4">
              <label>{{ $t('Brand') }}</label>
              <brandSelectorUnique :modelValue="brand" @onChange="setBrands" />
            </b-col>
          </b-row>
          <span v-if="permission.rewardProfile">
            <hr />
            <h6>{{ $t('Reward Settings') }}</h6>
            <b-row>
              <b-col md="6">
                <label>{{ $t('Reward Profile') }}</label>
                <rewardProfileSelector :modelValue="idRewardProfile" @onChange="selectProfile" />
              </b-col>
            </b-row>
          </span>
        </b-card>
        <b-row>
          <div>
            <button
              type="submit"
              class="btn btn-primary m-1"
              v-if="$route.params.id"
              :disabled="$store.state.isLoading"
            >
              {{ $t('Update') }}
            </button>
            <button type="submit" class="btn btn-primary m-1" :disabled="$store.state.isLoading" v-else>
              {{ $t('Create') }}
            </button>
            <button type="button" class="btn btn-secondary m-1" @click="$router.back()">
              {{ $t('Back') }}
            </button>
          </div>
        </b-row>
      </form>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import brandSelectorUnique from '@/components/selectors/brandSelectorUnique';
import rewardProfileSelector from '@/components/selectors/rewardProfileSelector';

export default {
  components: { Layout, brandSelectorUnique, rewardProfileSelector },
  data() {
    return {
      name: '',
      utmCampaign: '',
      promocode: '',
      brand: null,
      page: '',
      idRewardProfile: null,
      permission: {
        rewardProfile: false
      }
    };
  },
  mounted() {
    if (this.$route.params?.id) {
      this.getCampaign();
    }
    this.permission.rewardProfile = this.$utils.checkRole('rewardProfile');
  },
  methods: {
    formatUtms() {
      this.utmCampaign = this.$utils.toLower(this.utmCampaign);
    },
    saveCampaign() {
      if (this.$route.params?.id) {
        this.updateCampaign();
      } else {
        this.createCampaign();
      }
    },
    getCampaign() {
      const campaignId = this.$route.params.id;
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get(`api/campaign/${campaignId}`, {})
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          let campaign = res.data;

          this.name = campaign.name;
          this.utmCampaign = campaign.utm_campaign;
          this.promocode = campaign.promocode;
          this.brand = campaign.id_brand;
          this.idRewardProfile = campaign.id_reward_profile;
          this.page = campaign.page;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: this.$t('Error')
          });
        });
    },
    createCampaign() {
      if (!this.validateCampaign()) return;
      let campaign = {
        name: this.name,
        utmCampaign: this.utmCampaign,
        promocode: this.promocode,
        idBrand: this.brand,
        idRewardProfile: this.idRewardProfile,
        page: this.page
      };

      this.$store.commit('SET_LOADING', true);

      this.$api
        .post('api/campaign', campaign)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });

          this.$router.push({
            name: 'campaignList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Create campaign error')
          });
        });
    },
    updateCampaign() {
      if (!this.validateCampaign()) return;
      let campaignId = this.$route.params.id;
      let campaign = {
        name: this.name,
        utmCampaign: this.utmCampaign,
        promocode: this.promocode,
        idBrand: this.brand,
        idRewardProfile: this.idRewardProfile,
        page: this.page
      };

      this.$store.commit('SET_LOADING', true);
      this.$api
        .put(`api/campaign/${campaignId}`, campaign)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });
          this.$router.push({
            name: 'campaignList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Update campaign error')
          });
        });
    },
    validateCampaign() {
      if (!this.brand) {
        this.$customAlert({
          msg: this.$t('Invalid brand'),
          type: 'error'
        });
        return false;
      }
      if (!this.page) {
        this.$customAlert({
          msg: this.$t('Invalid page'),
          type: 'error'
        });
        return false;
      }
      if (!this.idRewardProfile) {
        this.$customAlert({
          msg: this.$t('Select a reward profile'),
          type: 'error'
        });
        return false;
      }
      if (this.$utils.hasSpecialChars(this.utmCampaign)) {
        this.$customAlert({
          msg: this.$t('Não é possível usar caracteres especiais'),
          type: 'error'
        });
        return false;
      }
      return true;
    },
    selectProfile(idRewardProfile) {
      this.idRewardProfile = idRewardProfile;
    },
    setBrands(brand = null) {
      this.brand = brand;
    }
  }
};
</script>

<style></style>
